import configs from "../configs";
import { getAuth0Token } from "../ui/utils";

export default class SettingsService {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.persistenceApiUrl = `${configs.PERSISTENCE_API_URL}`;
    this.customApiUrl = `${configs.CUSTOM_API_URL}`;
  }

  // Settings service methods will be added here as needed
}
